import {
  GET_ALL_PROJECTS,
  GET_DEALROOMS,
  GET_DEALROOM_FIN_STR,
  GET_DEALROOM_PROJECTS,
  EDIT_DEALROOM_FIN_STR,
  EDIT_DEALROOM,
  SET_SCENARIO_PROJECTS,
  SET_SCENARIO_FIN_STR,
  DELETE_PPROJECT_FROM_DEALROOM,
  DELETE_FIN_STR_FROM_DEALROOM,
  GET_DEALROOM_PROJECTS_SCENARIOS,
  GET_SCENARIO_PROJECTS,
  GET_SCENARIO_FIN_STRS,
} from "./../actions/types";
import {EDIT_DEALROOM_PROJECT, GET_DEALROOM_FIN_STR_SCENARIOS} from "../actions/types";

export default function (state = {}, action) {
  switch (action.type) {
    case GET_ALL_PROJECTS:

      return {...state, dealroomProjects: action.payload};
    case GET_DEALROOMS:

      return {...state, dealrooms: action.payload.items,dealroomsCount:action.payload.count};
    case GET_DEALROOM_PROJECTS:

      return {
        ...state,
        dealroomProjects: action.payload,
        scenarioProjectsShow: false,
        newProjectScenarioCreating: false
      };
    case GET_DEALROOM_FIN_STR:

      return {...state, dealroomFinStr: action.payload, scenarioFinStrShow: false};
    case GET_SCENARIO_PROJECTS:

      return {
        ...state,
        dealroomProjects: action.payload.user_projects,
        choosenProjectScenarioData: {id: action.payload.id, name: action.payload.name},
        scenarioProjectsShow: true,
        newProjectScenarioCreating: false
      };
    case GET_SCENARIO_FIN_STRS:
      return {
        ...state,
        dealroomFinStr: [action.payload],
        choosenFinStrScenarioData: {id: action.payload.id, name: action.payload.name},
        scenarioFinStrShow: true,
        newFinStrScenarioCreating: false
      };
    case EDIT_DEALROOM:

      return {...state, editPanding: false};
    case DELETE_PPROJECT_FROM_DEALROOM:
      let dealroomProjectForDelete = state.dealroomProjects;
      dealroomProjectForDelete = dealroomProjectForDelete.filter((project) => {
        console.log(project.id, action.payload);
        return project.id !== action.payload && project
      });

      return {...state, dealroomProjects: dealroomProjectForDelete};
    case DELETE_FIN_STR_FROM_DEALROOM:
      let dealroomFinStrForDelete = state.dealroomFinStr;
      dealroomFinStrForDelete = dealroomFinStrForDelete.filter((finstr) => {
        console.log(finstr.id, action.payload);
        return finstr.id !== action.payload && finstr
      });

      return {...state, dealroomFinStr: dealroomFinStrForDelete};
    case SET_SCENARIO_PROJECTS:
      const resultOfChoosenProject = state.dealroomProjects.filter((project, i) => {
        return action.payload.choosenProjectsArray.includes(i) && project
      });

      return {
        ...state,
        dealroomProjects: resultOfChoosenProject,
        scenarioProjectsShow: true,
        newProjectScenarioCreating: action.payload.newProjectScenarioCreating
      };
    case EDIT_DEALROOM_PROJECT:
      let dealroomProjects = state.dealroomProjects;
      const {projectId, project} = action.payload;

      dealroomProjects = dealroomProjects.map((dealroomProject) => {
        return projectId === dealroomProject.id ? project : dealroomProject;
      });
      return {...state, dealroomProjects, editPanding: true};
    case EDIT_DEALROOM_FIN_STR:
      let dealroomFinStr = state.dealroomFinStr;
      const {finStrId, financialStructure} = action.payload;

      dealroomFinStr = dealroomFinStr.map((dealroomFinStr) => {
        return finStrId === dealroomFinStr.id ? financialStructure : dealroomFinStr;
      });
      return {...state, dealroomFinStr, editPanding: true};
    case SET_SCENARIO_FIN_STR:
      const choosenFinStr = state.dealroomFinStr[action.payload.choosenFinStr];
      return {
        ...state,
        dealroomFinStr: [choosenFinStr],
        scenarioFinStrShow: true,
        newFinStrScenarioCreating: action.payload.newFinStrScenarioCreating
      };
    case GET_DEALROOM_PROJECTS_SCENARIOS:
      return {...state, dealroomProjectsScenarios: action.payload};
    case GET_DEALROOM_FIN_STR_SCENARIOS:
      return {...state, dealroomFinStrScenarios: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/dealroom.js